import React from 'react';
import { Route, useRouteMatch, Switch, Redirect } from 'react-router-dom';
import CreateAccount from './createAccount';
import Login from './login';
import ResetPassword from './resetPassword';
import UpdatePassword from './updatePassword';
import AuthLayout from './authLayout';
import OtpVerify from './otpVerify';

function Auth() {
  const { path } = useRouteMatch();

  return (
    <AuthLayout>
      <Switch>
        <Route exact path={path}>
          <Redirect to={`${path}/login`} />
        </Route>
        <Route path={`${path}/login`}>
          <Login />
        </Route>
        <Route path={`${path}/signup`}>
          <CreateAccount />
        </Route>
        <Route path={`${path}/update-password/:token`}>
          <UpdatePassword />
        </Route>
        <Route path={`${path}/reset-password`}>
          <ResetPassword />
        </Route>
        <Route path={`${path}/verify-otp`}>
          <OtpVerify />
        </Route>
      </Switch>
    </AuthLayout>
  );
}

export default Auth;
